import React from "react";

const About = (props) => {
  return <div>About</div>;
};

About.propTypes = {};

export default About;
